exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{font-family:Monospace;background-color:#f0f0f0;margin:0;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3f13c006!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/F3D.vue
// module id = 18
// module chunks = 0